import { LoginForm } from "./loginForm";
import { useAuth } from "../../Context/AuthContext";
import { SuspenseLoader } from "../../Layout/Common/loader";
import { logo } from "../../assets/imageImport";
import styles from "./mcpLoginGate.module.css";

export const McpLoginGate = ({ Component }) => {
  const { isAuthenticated, authLoading } = useAuth();

  if (authLoading) {
    return <SuspenseLoader show />;
  }

  if (!isAuthenticated) {
    const returnUrl = String(window.location.pathname || "") + String(window.location.search || "");

    return (
      <div className={styles.page}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.logoBadge}>
              <img src={logo} alt="WES" className={styles.logo} />
            </div>
          </div>
          <div className={styles.cardBody}>
            <div className="loginModal-popup">
              <div className="loginModal-header text-center">
                <h5>Please login to continue</h5>
                <p className="fw-normal col-fs-13 fs-14">
                  Sign in to your WES account to finish connecting your assistant.
                </p>
              </div>
              <LoginForm returnUrl={returnUrl} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!Component) {
    return null;
  }

  return <Component />;
};
